const EMAIL_PATTERN = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const validationRules = {
  required: value => !!value || "Required",
  email: value =>
    EMAIL_PATTERN.test(String(value || "")) || "Invalid email address",
  phone: (value, countryCode) => {
    const number = String(value || "");
    const country = String(countryCode || "");

    return (
      !number ||
      (country === "1"
        ? number.length >= 10
        : country.concat(number).length >= 8) ||
      "Phone is invalid"
    );
  }
};

export const normalizeEmail = value =>
  String(value || "").toLowerCase().trim();
